import { Outlet } from "react-router";
import { NavLink } from "react-router";
import HeaderNav from './Header'
import LeftMenu from './LeftMenu'
import Footer from './Footer'
import C1 from '../assets/images/c1.jpg'
import C2 from '../assets/images/c2.jpg'
import C3 from '../assets/images/c3.jpg'
import Hero from '../assets/images/2 Image.png'
import Brochure from "../assets/IETBHEC26_Brochure.pdf"

function Layout_Banner_2() {
    return (
        <>
            <div className="super_container">

                <div id="mySidenav" className="sidenav">
                    <LeftMenu />
                </div>

                <div className="home">
                    <HeaderNav />
                </div>

                {/* <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                    <ol className="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                    </ol>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={C1} className="d-block w-100 carousel-img" alt="..." height="350vh"/>
                            <div className="carousel-caption">
                                <h3 id="carousel-text"><strong>International Engineering, Technology, Business and Health Education Conference IETBHEC’26</strong></h3>
                                <p id="carousel-text"><strong>Singapore | 05 - 07 July 2026</strong></p>
                                <p id="carousel-text"><strong><em>Forging Futures Through Collaboration and Skill Empowerment: From Learning to Leading</em></strong></p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={C2} className="d-block w-100 carousel-img" alt="..." height="350vh"/>
                            <div className="carousel-caption">
                                <h3 id="carousel-text"><strong>International Engineering, Technology, Business and Health Education Conference IETBHEC’26</strong></h3>
                                <p id="carousel-text"><strong>Singapore | 05 - 07 July 2026</strong></p>
                                <p id="carousel-text"><strong><em>Forging Futures Through Collaboration and Skill Empowerment: From Learning to Leading</em></strong></p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={C3} className="d-block w-100 carousel-img" alt="..." height="350vh"/>
                            <div className="carousel-caption">
                                <h3 id="carousel-text"><strong>International Engineering, Technology, Business and Health Education Conference IETBHEC’26</strong></h3>
                                <p id="carousel-text"><strong>Singapore | 05 - 07 July 2026</strong></p>
                                <p id="carousel-text"><strong><em>Forging Futures Through Collaboration and Skill Empowerment: From Learning to Leading</em></strong></p>
                            </div>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-target="#carouselExampleIndicators" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-target="#carouselExampleIndicators" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </button>
                </div> */}

                <div className='hero-flex-box'>
                    <div className="hero-flex-left">
                        <h3><strong>International Engineering, Technology, Business and Health Education Conference IETBHEC’26</strong></h3>
                        {/* <br></br> */}
                        <p><strong>Singapore | 05 - 07 July 2026</strong></p>
                        {/* <br></br> */}
                        <NavLink to="/registration"><button id='hero-button'>Register here</button></NavLink>
                        <br></br>
                        <br></br>
                        <p><strong>Conference Brochure: </strong><a href={Brochure} target='_blank' rel="noreferrer noopener">IETBHEC26_Brochure.pdf</a></p>
                    </div>
                    <div className="hero-flex-right">
                        <img src={Hero} className="d-block w-100 carousel-img" alt="..." height="350vh"/>
                    </div>
                </div>

                <div className="content">
                    <Outlet />
                </div>

                <div>
                    <Footer />
                </div>
            </div >
        </>
    )
}

export default Layout_Banner_2